import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { REGISTER_ADAPTER } from '../../injection-tokens';
import { map } from 'rxjs';
import { AuthRouteSegments } from 'src/app/shared/constants';

export const registerGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const registerAdapter = inject(REGISTER_ADAPTER);

  return registerAdapter.canRegister(route).pipe(
    map((canRegister) => {
      return canRegister || router.createUrlTree([AuthRouteSegments.auth, AuthRouteSegments.login]);
    }),
  );
};
